import {assert} from 'Asserts';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {AnalysisFormulaParsingError} from 'pipelines/formula/Constants';
import formulaTextToFormulaAstJson from 'pipelines/formula/formulaTextToFormulaAstJson';

import {ConfigValidationFunction, AdditionalConfigValidationFunctions} from '../StepConfigValidationTypes';

const validateDraftConfig: ConfigValidationFunction<PipelineStepType.COMPUTED_COLUMN, 0, 'draft'> = (
  config
) => {
  if (!config.formula || !config.formula.formulaText || config.formula.formulaAst != null) {
    return [];
  }
  try {
    formulaTextToFormulaAstJson(config.formula.formulaText);
    assert(false, 'Config validation has valid formula text but null formula AST');
  } catch (e) {
    if (e instanceof AnalysisFormulaParsingError) {
      return [e.message];
    }
    throw e;
  }
};

export default {
  stepType: PipelineStepType.COMPUTED_COLUMN,
  stepVersion: 0,
  validateDraftConfig,
} satisfies AdditionalConfigValidationFunctions<PipelineStepType.COMPUTED_COLUMN, 0>;
